// extracted by mini-css-extract-plugin
export default {"formSectionContainer":"FormSection_formSectionContainer__tcJBl","headingContainer":"FormSection_headingContainer__zCIQw","formContainer":"FormSection_formContainer__7MjMj"};